var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".spinner_OSmW{transform-origin:center;animation:spinner_T6mA .75s step-end infinite}@keyframes spinner_T6mA{8.3%{transform:rotate(30deg)}16.6%{transform:rotate(60deg)}25%{transform:rotate(90deg)}33.3%{transform:rotate(120deg)}41.6%{transform:rotate(150deg)}50%{transform:rotate(180deg)}58.3%{transform:rotate(210deg)}66.6%{transform:rotate(240deg)}75%{transform:rotate(270deg)}83.3%{transform:rotate(300deg)}91.6%{transform:rotate(330deg)}100%{transform:rotate(360deg)}}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "spinner_OSmW"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 5,
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 5,
    transform: "rotate(30 12 12)",
    opacity: 0.29
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 5,
    transform: "rotate(60 12 12)",
    opacity: 0.43
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 5,
    transform: "rotate(90 12 12)",
    opacity: 0.57
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 5,
    transform: "rotate(120 12 12)",
    opacity: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 5,
    transform: "rotate(150 12 12)",
    opacity: 0.86
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 1,
    width: 2,
    height: 5,
    transform: "rotate(180 12 12)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.d20855f5ade5769e4add85dba4c5b5ed.svg";
export { ForwardRef as ReactComponent };